var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.003 14.015c3.449 0 6.26-3.091 6.26-6.852C19.263 3.43 16.466.5 13.003.5 9.57.5 6.744 3.489 6.744 7.192c.015 3.746 2.81 6.823 6.26 6.823m0-2.202c-2.115 0-3.926-2.04-3.926-4.621 0-2.537 1.782-4.49 3.926-4.49 2.16 0 3.927 1.924 3.927 4.46 0 2.581-1.797 4.651-3.927 4.651M3.89 27.5h18.213c2.405 0 3.55-.729 3.55-2.333 0-3.82-4.797-9.345-12.65-9.345C5.136 15.822.34 21.348.34 25.167c0 1.604 1.144 2.333 3.55 2.333m-.681-2.201c-.377 0-.536-.102-.536-.409 0-2.39 3.68-6.866 10.33-6.866 6.636 0 10.317 4.476 10.317 6.866 0 .306-.145.409-.522.409z"
  })));
};
export default SvgUser;